module.exports = __webpack_public_path__ + "static/media/bg.3d762564.svg";